import React from 'react';
import excel from '../../assets/excel.png';

const ExcelFile = () => {
  return (
    <div className='popup-container'>
      <div className="polygon excel"></div>
      <div className="ui raised very padded text container segment popup-box email-box">
        <div className="header-box">
          <img className="image excel icon" src={excel} alt="" />
          <h3 className="title">Excel Inbox</h3>
        </div>
        <div className="section">
          <div className="ui stackable two column grid">
            <div className="nine wide column">
              <div className="ui secondary segment">
                <div className="ui divided list">
                  <div className="item">
                    <div className="content">
                      <p>
                        <span className="left floated">
                          You have Been Approved
                        </span>
                        <span className="right floated">6:34 PM</span>
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="content">
                      <p>
                        <span className="left floated">Accounts Details</span>
                        <span className="right floated">6:29 PM</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="seven wide column">
              <div className="content_box">
                <div className="subject_box">
                  <p>
                    FROM: <span>Manuel Garcia/Third</span>
                  </p>
                  <p>
                    SUBJECT: <span>You have been approved</span>
                  </p>
                </div>
                <div className="compose_box">
                  <p>
                    Good Morning. We are pleased to approved. We wish you the
                    best.
                  </p>
                  <p>Very Best,</p>
                  <p>Manuel Garcia</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  )
}

export default ExcelFile